import React from "react";
import styled, { css } from "styled-components";

const EyebrowSmStyle = css`
  font-family: ${({ theme }) => theme.fonts.graphik};
  font-weight: 500;
  color: ${({ theme, color }) => color || theme.colors.black};
  font-size: 0.5625rem;
  line-height: 100%;
  letter-spacing: 10%;
  text-transform: uppercase;
  ${({ theme }) => theme.media.tabletUp`
    font-size: 0.75rem;
  `};
`;

const StyledText = styled.p`
  ${EyebrowSmStyle}
`;

const EyebrowSm = ({ children, className, color }) => {
  return (
    <StyledText color={color} className={className}>
      {children}
    </StyledText>
  );
};

export default EyebrowSm;
export { EyebrowSmStyle };
